<template>
  <!-- <div class="chart-content">
    <div class="chart" ref="myChart">
    </div>
  </div> -->
  <BaseBarLine :name='name' :getDataAction='getDataAction' :leftName='legtName' :rightName='rightName' :isShowCloseBtn='isShowCloseBtn' @SizeChange='sizeChange' @StateChange='stateChange'></BaseBarLine>
</template>

<script>
import BaseBarLine from './../baseBarLine.vue'
// import elementResizeDetectorMaker from "element-resize-detector";
// import BaseReportMixin from '@/mixin/baseReport-mixin.js'
import {
  GetStockUpsageTrendChart
} from '@/api'
export default ({
  components: {
    BaseBarLine
  },
  // mixins: [BaseReportMixin],
  data () {
    return {
      getDataAction: GetStockUpsageTrendChart,
      legtName: '备货',
      rightName: '使用'
      // myChart: null,
      // option: {},
      // data: [],
      // nameData: [],
      // lineDate: [],
    };
  },
  props: {
    name: {
      type: String,
      default () {
        return ''
      }
    },
    isShowCloseBtn: {
      type: Boolean,
      default () {
        return true
      }
    }
  },
  //监听beforinfo值的变化
  watch: {
    // data: {
    //   handler (newVal, oldVal) {
    //     this.initOption()
    //     this.option.series[0].data = newVal
    //     if (!this.myChart) {
    //       this.myChart = this.$echarts.init(this.$refs['myChart'])
    //     }
    //     this.myChart.setOption(this.option);
    //   },
    //   deep: true
    // },
    // lineDate: {
    //   handler (newVal, oldVal) {
    //     this.initOption()
    //     this.option.series[1].data = newVal
    //     if (!this.myChart) {
    //       this.myChart = this.$echarts.init(this.$refs['myChart'])
    //     }
    //     this.myChart.setOption(this.option);
    //   },
    //   deep: true
    // },
  },
  methods: {
    sizeChange (a, b, c, d) {
      this.$emit('SizeChange', a, b, c, d)
    },
    stateChange (a, b) {
      this.$emit('StateChange', a, b)
    },
  },//自定义指令


  mounted () {
    // this.init()
  },
  /** 生命周期 - 创建完成（可以访问当前this实例） */
  created () {
    // this.getData();
  },
})
</script>
<style scoped lang="scss">
</style>
